"use strict";

var _slicedToArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Zora = void 0;

var tslib_1 = require("tslib");

var Decimal_1 = require("./Decimal");

var abstract_signer_1 = require("@ethersproject/abstract-signer");

var typechain_1 = require("@zoralabs/core/dist/typechain");

var addresses_1 = require("./addresses");

var utils_1 = require("./utils");

var tiny_invariant_1 = tslib_1.__importDefault(require("tiny-invariant"));

var Zora = /*#__PURE__*/function () {
  function Zora(signerOrProvider, chainId, mediaAddress, marketAddress) {
    _classCallCheck(this, Zora);

    if (!mediaAddress != !marketAddress) {
      tiny_invariant_1.default(false, 'Zora Constructor: mediaAddress and marketAddress must both be non-null or both be null');
    }

    if (abstract_signer_1.Signer.isSigner(signerOrProvider)) {
      this.readOnly = false;
    } else {
      this.readOnly = true;
    }

    this.signerOrProvider = signerOrProvider;
    this.chainId = chainId;

    if (mediaAddress && marketAddress) {
      var parsedMediaAddress = utils_1.validateAndParseAddress(mediaAddress);
      var parsedMarketAddress = utils_1.validateAndParseAddress(marketAddress);
      this.mediaAddress = parsedMediaAddress;
      this.marketAddress = parsedMarketAddress;
    } else {
      var network = utils_1.chainIdToNetworkName(chainId);
      this.mediaAddress = addresses_1.addresses[network].media;
      this.marketAddress = addresses_1.addresses[network].market;
    }

    this.media = typechain_1.MediaFactory.connect(this.mediaAddress, signerOrProvider);
    this.market = typechain_1.MarketFactory.connect(this.marketAddress, signerOrProvider);
  }
  /*********************
   * Zora View Methods
   *********************
   */

  /**
   * Fetches the content hash for the specified media on the Zora Media Contract
   * @param mediaId
   */


  _createClass(Zora, [{
    key: "fetchContentHash",
    value: function () {
      var _fetchContentHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(mediaId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.media.tokenContentHashes(mediaId));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchContentHash(_x) {
        return _fetchContentHash.apply(this, arguments);
      }

      return fetchContentHash;
    }()
    /**
     * Fetches the metadata hash for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "fetchMetadataHash",
    value: function () {
      var _fetchMetadataHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(mediaId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.media.tokenMetadataHashes(mediaId));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchMetadataHash(_x2) {
        return _fetchMetadataHash.apply(this, arguments);
      }

      return fetchMetadataHash;
    }()
    /**
     * Fetches the content uri for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "fetchContentURI",
    value: function () {
      var _fetchContentURI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(mediaId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.media.tokenURI(mediaId));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchContentURI(_x3) {
        return _fetchContentURI.apply(this, arguments);
      }

      return fetchContentURI;
    }()
    /**
     * Fetches the metadata uri for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "fetchMetadataURI",
    value: function () {
      var _fetchMetadataURI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(mediaId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.media.tokenMetadataURI(mediaId));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchMetadataURI(_x4) {
        return _fetchMetadataURI.apply(this, arguments);
      }

      return fetchMetadataURI;
    }()
    /**
     * Fetches the creator for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "fetchCreator",
    value: function () {
      var _fetchCreator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(mediaId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.media.tokenCreators(mediaId));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchCreator(_x5) {
        return _fetchCreator.apply(this, arguments);
      }

      return fetchCreator;
    }()
    /**
     * Fetches the current bid shares for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "fetchCurrentBidShares",
    value: function () {
      var _fetchCurrentBidShares = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(mediaId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.market.bidSharesForToken(mediaId));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchCurrentBidShares(_x6) {
        return _fetchCurrentBidShares.apply(this, arguments);
      }

      return fetchCurrentBidShares;
    }()
    /**
     * Fetches the current ask for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "fetchCurrentAsk",
    value: function () {
      var _fetchCurrentAsk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(mediaId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.market.currentAskForToken(mediaId));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function fetchCurrentAsk(_x7) {
        return _fetchCurrentAsk.apply(this, arguments);
      }

      return fetchCurrentAsk;
    }()
    /**
     * Fetches the current bid for the specified bidder for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     * @param bidder
     */

  }, {
    key: "fetchCurrentBidForBidder",
    value: function () {
      var _fetchCurrentBidForBidder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(mediaId, bidder) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.market.bidForTokenBidder(mediaId, bidder));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function fetchCurrentBidForBidder(_x8, _x9) {
        return _fetchCurrentBidForBidder.apply(this, arguments);
      }

      return fetchCurrentBidForBidder;
    }()
    /**
     * Fetches the permit nonce on the specified media id for the owner address
     * @param address
     * @param mediaId
     */

  }, {
    key: "fetchPermitNonce",
    value: function () {
      var _fetchPermitNonce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(address, mediaId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this.media.permitNonces(address, mediaId));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function fetchPermitNonce(_x10, _x11) {
        return _fetchPermitNonce.apply(this, arguments);
      }

      return fetchPermitNonce;
    }()
    /**
     * Fetches the current mintWithSig nonce for the specified address
     * @param address
     * @param mediaId
     */

  }, {
    key: "fetchMintWithSigNonce",
    value: function () {
      var _fetchMintWithSigNonce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(address) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this.media.mintWithSigNonces(address));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetchMintWithSigNonce(_x12) {
        return _fetchMintWithSigNonce.apply(this, arguments);
      }

      return fetchMintWithSigNonce;
    }()
    /*********************
     * Zora Write Methods
     *********************
     */

    /**
     * Updates the content uri for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     * @param tokenURI
     */

  }, {
    key: "updateContentURI",
    value: function () {
      var _updateContentURI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(mediaId, tokenURI) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                this.ensureNotReadOnly();
                utils_1.validateURI(tokenURI);
                _context11.next = 8;
                break;

              case 5:
                _context11.prev = 5;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", Promise.reject(_context11.t0.message));

              case 8:
                return _context11.abrupt("return", this.media.updateTokenURI(mediaId, tokenURI));

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 5]]);
      }));

      function updateContentURI(_x13, _x14) {
        return _updateContentURI.apply(this, arguments);
      }

      return updateContentURI;
    }()
    /**
     * Updates the metadata uri for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     * @param metadataURI
     */

  }, {
    key: "updateMetadataURI",
    value: function () {
      var _updateMetadataURI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(mediaId, metadataURI) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                this.ensureNotReadOnly();
                utils_1.validateURI(metadataURI);
                _context12.next = 8;
                break;

              case 5:
                _context12.prev = 5;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", Promise.reject(_context12.t0.message));

              case 8:
                return _context12.abrupt("return", this.media.updateTokenMetadataURI(mediaId, metadataURI));

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 5]]);
      }));

      function updateMetadataURI(_x15, _x16) {
        return _updateMetadataURI.apply(this, arguments);
      }

      return updateMetadataURI;
    }()
    /**
     * Mints a new piece of media on an instance of the Zora Media Contract
     * @param mintData
     * @param bidShares
     */

  }, {
    key: "mint",
    value: function () {
      var _mint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(mediaData, bidShares) {
        var gasEstimate, paddedEstimate;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                this.ensureNotReadOnly();
                utils_1.validateURI(mediaData.metadataURI);
                utils_1.validateURI(mediaData.tokenURI);
                utils_1.validateBidShares(bidShares.creator, bidShares.owner, bidShares.prevOwner);
                _context13.next = 10;
                break;

              case 7:
                _context13.prev = 7;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", Promise.reject(_context13.t0.message));

              case 10:
                _context13.next = 12;
                return this.media.estimateGas.mint(mediaData, bidShares);

              case 12:
                gasEstimate = _context13.sent;
                paddedEstimate = gasEstimate.mul(110).div(100);
                return _context13.abrupt("return", this.media.mint(mediaData, bidShares, {
                  gasLimit: paddedEstimate.toString()
                }));

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 7]]);
      }));

      function mint(_x17, _x18) {
        return _mint.apply(this, arguments);
      }

      return mint;
    }()
    /**
     * Mints a new piece of media on an instance of the Zora Media Contract
     * @param creator
     * @param mediaData
     * @param bidShares
     * @param sig
     */

  }, {
    key: "mintWithSig",
    value: function () {
      var _mintWithSig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(creator, mediaData, bidShares, sig) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                this.ensureNotReadOnly();
                utils_1.validateURI(mediaData.metadataURI);
                utils_1.validateURI(mediaData.tokenURI);
                utils_1.validateBidShares(bidShares.creator, bidShares.owner, bidShares.prevOwner);
                _context14.next = 10;
                break;

              case 7:
                _context14.prev = 7;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", Promise.reject(_context14.t0.message));

              case 10:
                return _context14.abrupt("return", this.media.mintWithSig(creator, mediaData, bidShares, sig));

              case 11:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 7]]);
      }));

      function mintWithSig(_x19, _x20, _x21, _x22) {
        return _mintWithSig.apply(this, arguments);
      }

      return mintWithSig;
    }()
    /**
     * Sets an ask on the specified media on an instance of the Zora Media Contract
     * @param mediaId
     * @param ask
     */

  }, {
    key: "setAsk",
    value: function () {
      var _setAsk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(mediaId, ask) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                this.ensureNotReadOnly();
                _context15.next = 7;
                break;

              case 4:
                _context15.prev = 4;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", Promise.reject(_context15.t0.message));

              case 7:
                return _context15.abrupt("return", this.media.setAsk(mediaId, ask));

              case 8:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 4]]);
      }));

      function setAsk(_x23, _x24) {
        return _setAsk.apply(this, arguments);
      }

      return setAsk;
    }()
    /**
     * Sets a bid on the specified media on an instance of the Zora Media Contract
     * @param mediaId
     * @param bid
     */

  }, {
    key: "setBid",
    value: function () {
      var _setBid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(mediaId, bid) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                this.ensureNotReadOnly();
                _context16.next = 7;
                break;

              case 4:
                _context16.prev = 4;
                _context16.t0 = _context16["catch"](0);
                return _context16.abrupt("return", Promise.reject(_context16.t0.message));

              case 7:
                return _context16.abrupt("return", this.media.setBid(mediaId, bid));

              case 8:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 4]]);
      }));

      function setBid(_x25, _x26) {
        return _setBid.apply(this, arguments);
      }

      return setBid;
    }()
    /**
     * Removes the ask on the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "removeAsk",
    value: function () {
      var _removeAsk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(mediaId) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                this.ensureNotReadOnly();
                _context17.next = 7;
                break;

              case 4:
                _context17.prev = 4;
                _context17.t0 = _context17["catch"](0);
                return _context17.abrupt("return", Promise.reject(_context17.t0.message));

              case 7:
                return _context17.abrupt("return", this.media.removeAsk(mediaId));

              case 8:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 4]]);
      }));

      function removeAsk(_x27) {
        return _removeAsk.apply(this, arguments);
      }

      return removeAsk;
    }()
    /**
     * Removes the bid for the msg.sender on the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "removeBid",
    value: function () {
      var _removeBid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(mediaId) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                this.ensureNotReadOnly();
                _context18.next = 7;
                break;

              case 4:
                _context18.prev = 4;
                _context18.t0 = _context18["catch"](0);
                return _context18.abrupt("return", Promise.reject(_context18.t0.message));

              case 7:
                return _context18.abrupt("return", this.media.removeBid(mediaId));

              case 8:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 4]]);
      }));

      function removeBid(_x28) {
        return _removeBid.apply(this, arguments);
      }

      return removeBid;
    }()
    /**
     * Accepts the specified bid on the specified media on an instance of the Zora Media Contract
     * @param mediaId
     * @param bid
     */

  }, {
    key: "acceptBid",
    value: function () {
      var _acceptBid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(mediaId, bid) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                this.ensureNotReadOnly();
                _context19.next = 7;
                break;

              case 4:
                _context19.prev = 4;
                _context19.t0 = _context19["catch"](0);
                return _context19.abrupt("return", Promise.reject(_context19.t0.message));

              case 7:
                return _context19.abrupt("return", this.media.acceptBid(mediaId, bid));

              case 8:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 4]]);
      }));

      function acceptBid(_x29, _x30) {
        return _acceptBid.apply(this, arguments);
      }

      return acceptBid;
    }()
    /**
     * Grants the spender approval for the specified media using meta transactions as outlined in EIP-712
     * @param sender
     * @param mediaId
     * @param sig
     */

  }, {
    key: "permit",
    value: function () {
      var _permit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(spender, mediaId, sig) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                this.ensureNotReadOnly();
                _context20.next = 7;
                break;

              case 4:
                _context20.prev = 4;
                _context20.t0 = _context20["catch"](0);
                return _context20.abrupt("return", Promise.reject(_context20.t0.message));

              case 7:
                return _context20.abrupt("return", this.media.permit(spender, mediaId, sig));

              case 8:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 4]]);
      }));

      function permit(_x31, _x32, _x33) {
        return _permit.apply(this, arguments);
      }

      return permit;
    }()
    /**
     * Revokes the approval of an approved account for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "revokeApproval",
    value: function () {
      var _revokeApproval = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(mediaId) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                this.ensureNotReadOnly();
                _context21.next = 7;
                break;

              case 4:
                _context21.prev = 4;
                _context21.t0 = _context21["catch"](0);
                return _context21.abrupt("return", Promise.reject(_context21.t0.message));

              case 7:
                return _context21.abrupt("return", this.media.revokeApproval(mediaId));

              case 8:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[0, 4]]);
      }));

      function revokeApproval(_x34) {
        return _revokeApproval.apply(this, arguments);
      }

      return revokeApproval;
    }()
    /**
     * Burns the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "burn",
    value: function () {
      var _burn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(mediaId) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                this.ensureNotReadOnly();
                _context22.next = 7;
                break;

              case 4:
                _context22.prev = 4;
                _context22.t0 = _context22["catch"](0);
                return _context22.abrupt("return", Promise.reject(_context22.t0.message));

              case 7:
                return _context22.abrupt("return", this.media.burn(mediaId));

              case 8:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[0, 4]]);
      }));

      function burn(_x35) {
        return _burn.apply(this, arguments);
      }

      return burn;
    }()
    /***********************
     * ERC-721 View Methods
     ***********************
     */

    /**
     * Fetches the total balance of media owned by the specified owner on an instance of the Zora Media Contract
     * @param owner
     */

  }, {
    key: "fetchBalanceOf",
    value: function () {
      var _fetchBalanceOf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(owner) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this.media.balanceOf(owner));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function fetchBalanceOf(_x36) {
        return _fetchBalanceOf.apply(this, arguments);
      }

      return fetchBalanceOf;
    }()
    /**
     * Fetches the owner of the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "fetchOwnerOf",
    value: function () {
      var _fetchOwnerOf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(mediaId) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", this.media.ownerOf(mediaId));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function fetchOwnerOf(_x37) {
        return _fetchOwnerOf.apply(this, arguments);
      }

      return fetchOwnerOf;
    }()
    /**
     * Fetches the mediaId of the specified owner by index on an instance of the Zora Media Contract
     * @param owner
     * @param index
     */

  }, {
    key: "fetchMediaOfOwnerByIndex",
    value: function () {
      var _fetchMediaOfOwnerByIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(owner, index) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this.media.tokenOfOwnerByIndex(owner, index));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function fetchMediaOfOwnerByIndex(_x38, _x39) {
        return _fetchMediaOfOwnerByIndex.apply(this, arguments);
      }

      return fetchMediaOfOwnerByIndex;
    }()
    /**
     * Fetches the total amount of non-burned media that has been minted on an instance of the Zora Media Contract
     */

  }, {
    key: "fetchTotalMedia",
    value: function () {
      var _fetchTotalMedia = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", this.media.totalSupply());

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function fetchTotalMedia() {
        return _fetchTotalMedia.apply(this, arguments);
      }

      return fetchTotalMedia;
    }()
    /**
     * Fetches the mediaId by index on an instance of the Zora Media Contract
     * @param index
     */

  }, {
    key: "fetchMediaByIndex",
    value: function () {
      var _fetchMediaByIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(index) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this.media.tokenByIndex(index));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function fetchMediaByIndex(_x40) {
        return _fetchMediaByIndex.apply(this, arguments);
      }

      return fetchMediaByIndex;
    }()
    /**
     * Fetches the approved account for the specified media on an instance of the Zora Media Contract
     * @param mediaId
     */

  }, {
    key: "fetchApproved",
    value: function () {
      var _fetchApproved = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(mediaId) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", this.media.getApproved(mediaId));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function fetchApproved(_x41) {
        return _fetchApproved.apply(this, arguments);
      }

      return fetchApproved;
    }()
    /**
     * Fetches if the specified operator is approved for all media owned by the specified owner on an instance of the Zora Media Contract
     * @param owner
     * @param operator
     */

  }, {
    key: "fetchIsApprovedForAll",
    value: function () {
      var _fetchIsApprovedForAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(owner, operator) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", this.media.isApprovedForAll(owner, operator));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function fetchIsApprovedForAll(_x42, _x43) {
        return _fetchIsApprovedForAll.apply(this, arguments);
      }

      return fetchIsApprovedForAll;
    }()
    /***********************
     * ERC-721 Write Methods
     ***********************
     */

    /**
     * Grants approval to the specified address for the specified media on an instance of the Zora Media Contract
     * @param to
     * @param mediaId
     */

  }, {
    key: "approve",
    value: function () {
      var _approve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(to, mediaId) {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                this.ensureNotReadOnly();
                _context30.next = 7;
                break;

              case 4:
                _context30.prev = 4;
                _context30.t0 = _context30["catch"](0);
                return _context30.abrupt("return", Promise.reject(_context30.t0.message));

              case 7:
                return _context30.abrupt("return", this.media.approve(to, mediaId));

              case 8:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this, [[0, 4]]);
      }));

      function approve(_x44, _x45) {
        return _approve.apply(this, arguments);
      }

      return approve;
    }()
    /**
     * Grants approval for all media owner by msg.sender on an instance of the Zora Media Contract
     * @param operator
     * @param approved
     */

  }, {
    key: "setApprovalForAll",
    value: function () {
      var _setApprovalForAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(operator, approved) {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;
                this.ensureNotReadOnly();
                _context31.next = 7;
                break;

              case 4:
                _context31.prev = 4;
                _context31.t0 = _context31["catch"](0);
                return _context31.abrupt("return", Promise.reject(_context31.t0.message));

              case 7:
                return _context31.abrupt("return", this.media.setApprovalForAll(operator, approved));

              case 8:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this, [[0, 4]]);
      }));

      function setApprovalForAll(_x46, _x47) {
        return _setApprovalForAll.apply(this, arguments);
      }

      return setApprovalForAll;
    }()
    /**
     * Transfers the specified media to the specified to address on an instance of the Zora Media Contract
     * @param from
     * @param to
     * @param mediaId
     */

  }, {
    key: "transferFrom",
    value: function () {
      var _transferFrom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(from, to, mediaId) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.prev = 0;
                this.ensureNotReadOnly();
                _context32.next = 7;
                break;

              case 4:
                _context32.prev = 4;
                _context32.t0 = _context32["catch"](0);
                return _context32.abrupt("return", Promise.reject(_context32.t0.message));

              case 7:
                return _context32.abrupt("return", this.media.transferFrom(from, to, mediaId));

              case 8:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this, [[0, 4]]);
      }));

      function transferFrom(_x48, _x49, _x50) {
        return _transferFrom.apply(this, arguments);
      }

      return transferFrom;
    }()
    /**
     * Executes a SafeTransfer of the specified media to the specified address if and only if it adheres to the ERC721-Receiver Interface
     * @param from
     * @param to
     * @param mediaId
     */

  }, {
    key: "safeTransferFrom",
    value: function () {
      var _safeTransferFrom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(from, to, mediaId) {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.prev = 0;
                this.ensureNotReadOnly();
                _context33.next = 7;
                break;

              case 4:
                _context33.prev = 4;
                _context33.t0 = _context33["catch"](0);
                return _context33.abrupt("return", Promise.reject(_context33.t0.message));

              case 7:
                return _context33.abrupt("return", this.media.safeTransferFrom(from, to, mediaId));

              case 8:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this, [[0, 4]]);
      }));

      function safeTransferFrom(_x51, _x52, _x53) {
        return _safeTransferFrom.apply(this, arguments);
      }

      return safeTransferFrom;
    }()
    /****************
     * Miscellaneous
     * **************
     */

    /**
     * Returns the EIP-712 Domain for an instance of the Zora Media Contract
     */

  }, {
    key: "eip712Domain",
    value: function eip712Domain() {
      // Due to a bug in ganache-core, set the chainId to 1 if its a local blockchain
      // https://github.com/trufflesuite/ganache-core/issues/515
      var chainId = this.chainId == 50 ? 1 : this.chainId;
      return {
        name: 'Zora',
        version: '1',
        chainId: chainId,
        verifyingContract: this.mediaAddress
      };
    }
    /**
     * Checks to see if a Bid's amount is evenly splittable given the media's current bidShares
     *
     * @param mediaId
     * @param bid
     */

  }, {
    key: "isValidBid",
    value: function () {
      var _isValidBid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(mediaId, bid) {
        var isAmountValid, decimal100, currentBidShares, isSellOnShareValid;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return this.market.isValidBid(mediaId, bid.amount);

              case 2:
                isAmountValid = _context34.sent;
                decimal100 = Decimal_1.Decimal.new(100);
                _context34.next = 6;
                return this.fetchCurrentBidShares(mediaId);

              case 6:
                currentBidShares = _context34.sent;
                isSellOnShareValid = bid.sellOnShare.value.lte(decimal100.value.sub(currentBidShares.creator.value));
                return _context34.abrupt("return", isAmountValid && isSellOnShareValid);

              case 9:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function isValidBid(_x54, _x55) {
        return _isValidBid.apply(this, arguments);
      }

      return isValidBid;
    }()
    /**
     * Checks to see if an Ask's amount is evenly splittable given the media's current bidShares
     *
     * @param mediaId
     * @param ask
     */

  }, {
    key: "isValidAsk",
    value: function isValidAsk(mediaId, ask) {
      return this.market.isValidBid(mediaId, ask.amount);
    }
    /**
     * Checks to see if a piece of media has verified uris that hash to their immutable hashes
     *
     * @param mediaId
     * @param timeout
     */

  }, {
    key: "isVerifiedMedia",
    value: function () {
      var _isVerifiedMedia = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(mediaId) {
        var timeout,
            _yield$Promise$all,
            _yield$Promise$all2,
            tokenURI,
            metadataURI,
            contentHash,
            metadataHash,
            mediaData,
            _args35 = arguments;

        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                timeout = _args35.length > 1 && _args35[1] !== undefined ? _args35[1] : 10;
                _context35.prev = 1;
                _context35.next = 4;
                return Promise.all([this.fetchContentURI(mediaId), this.fetchMetadataURI(mediaId), this.fetchContentHash(mediaId), this.fetchMetadataHash(mediaId)]);

              case 4:
                _yield$Promise$all = _context35.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
                tokenURI = _yield$Promise$all2[0];
                metadataURI = _yield$Promise$all2[1];
                contentHash = _yield$Promise$all2[2];
                metadataHash = _yield$Promise$all2[3];
                mediaData = utils_1.constructMediaData(tokenURI, metadataURI, contentHash, metadataHash);
                return _context35.abrupt("return", utils_1.isMediaDataVerified(mediaData, timeout));

              case 14:
                _context35.prev = 14;
                _context35.t0 = _context35["catch"](1);
                return _context35.abrupt("return", Promise.reject(_context35.t0.message));

              case 17:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this, [[1, 14]]);
      }));

      function isVerifiedMedia(_x56) {
        return _isVerifiedMedia.apply(this, arguments);
      }

      return isVerifiedMedia;
    }()
    /******************
     * Private Methods
     ******************
     */

    /**
     * Throws an error if called on a readOnly == true instance of Zora Sdk
     * @private
     */

  }, {
    key: "ensureNotReadOnly",
    value: function ensureNotReadOnly() {
      if (this.readOnly) {
        throw new Error('ensureNotReadOnly: readOnly Zora instance cannot call contract methods that require a signer.');
      }
    }
  }]);

  return Zora;
}();

exports.Zora = Zora;